export const LATE_JOIN_BANNER_COPY = {
  TITLE: 'You joined mid-tournament',
  BODY: "Matches played before you joined don't count toward your score — play every match from here!",
} as const;

export const LATE_JOIN_BANNER_TEST_IDS = {
  ROOT: 'worldcup-late-join-banner',
  DISMISS: 'worldcup-late-join-banner-dismiss',
} as const;
